import { Injectable } from '@angular/core';
import { Observable, of, catchError, throwError } from 'rxjs';
import { FilterDTO, SavedReportFileDTO, UserExtractReportSummaryDTO, SortDirection, UserExtractReportClient, DateRangeParameterDTO, PagedResultDTOOfUserExtractReportDTO } from 'src/app/base/models/models.swagger.generated';
import { ToastService } from 'src/app/base/services/toast.service';
import { ShowInactiveService } from 'src/app/base/shared/grid-base/show-inactive.service';
import { IAdaptorService } from 'src/app/base/shared/syncfusion/adaptor-service.interface';
import { ErrorType } from 'src/app/core/routing/error-types';
import { SaveOptions } from '../../reports-footer/save-options';

@Injectable()
export class UserExtractReportService extends ShowInactiveService implements IAdaptorService {

  public reportParameters: DateRangeParameterDTO = null;

  constructor(
    private toastService: ToastService,
    private userExtractReportClient: UserExtractReportClient) {
    super();
  }

  public getData(skip: number, take: number, filters: FilterDTO[], sortBy: string, sortDirection: SortDirection): Observable<PagedResultDTOOfUserExtractReportDTO> {
    if (!this.reportParameters) {
      return of(new PagedResultDTOOfUserExtractReportDTO({items: [], totalNumberOfItems: 0}));
    }

    return this.userExtractReportClient.searchUserExtractReportData(this.reportParameters, skip, take, undefined).pipe(
      catchError((error: any) => {
        if (!this.toastService.doesErrorExistAlready(ErrorType.serverError)) {
          this.toastService.showError('i18n.errors.server-error.title', 'i18n.errors.server-error.message', null, ErrorType.serverError);
        }
        return throwError(() => error);
      }),
    );
  }

  public addRecord(data: any): Observable<any> {
    throw new Error('Method not implemented.');
  }

  public updateRecord(data: any): Observable<any> {
    throw new Error('Method not implemented.');
  }

  public deleteRecord(id: number): Observable<any> {
    throw new Error('Method not implemented.');
  }

  public exportReport(parameters: DateRangeParameterDTO, saveOptions: SaveOptions): Observable<SavedReportFileDTO> {
    return this.userExtractReportClient.exportUserExtractReport(
      saveOptions.exportType,
      saveOptions.saveReport,
      parameters
    )
      .pipe(
        catchError((error: any) => {
          if (!this.toastService.doesErrorExistAlready(ErrorType.serverError)) {
            this.toastService.showError('i18n.errors.server-error.title', 'i18n.errors.server-error.message', null, ErrorType.serverError);
          }
          return throwError(() => error);
        }),
      );
  }

  public getReportSummary(parameters: DateRangeParameterDTO): Observable<UserExtractReportSummaryDTO> {
    return this.userExtractReportClient.summarizeUserExtractReport(parameters)
      .pipe(
        catchError((error: any) => {
          if (!this.toastService.doesErrorExistAlready(ErrorType.serverError)) {
            this.toastService.showError('i18n.errors.server-error.title', 'i18n.errors.server-error.message', null, ErrorType.serverError);
          }
          return throwError(() => error);
        }),
      );
  }
}
